import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import BgImg from "../../images/services-usa/telecom-services/why-choose-bg.webp";

function Whychooseecommerce() {
  return (
    <section
      className="trusted_ecommerce_web ecommerce_why_choose p-100"
      style={{
        backgroundImage: `url(${BgImg})`,
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      <Container>
        <Row>
          <Col xs={12} md={6} lg={6} xl={6} xxl={6}>
            <h2 style={{ color: "#fff" }}>
              Why Choose TekRevol For <span>Telecommunication</span> Software
              Development?
            </h2>
          </Col>
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="mt-3 mt-md-0">
            <p style={{ color: "#fff" }}>
              We are a leading telecom software development company specializing
              in assisting clients enhance operational efficiency. To address
              certain issues, our specialists develop telecom software that is
              individual for each task, relying on progressive technologies and
              focusing on a client’s present and future needs.
            </p>
          </Col>
        </Row>
        <Row>
          <Col xs={12} md={12} lg={12} xl={12} xxl={12}>
            <Row className="mt-3 mt-md-5">
              <Col xs={12} md={6} lg={6} xl={4} xxl={4} className="mb-4">
                <div
                  className="trusted_ecomm_box"
                  style={{ background: "#31475F" }}
                >
                  <div className="ecomm_title">01</div>
                  <div className="ecomm_box_content">
                    <h5>Security & Compliance</h5>
                    <p>
                      TekRevol guarantees that your telecom software aligns with
                      industry regulations, ensuring the protection of sensitive
                      data from development to deployment.
                    </p>
                  </div>
                </div>
              </Col>
              <Col xs={12} md={6} lg={6} xl={4} xxl={4} className="mb-4">
                <div
                  className="trusted_ecomm_box"
                  style={{ background: "#31475F" }}
                >
                  <div className="ecomm_title">02</div>
                  <div className="ecomm_box_content">
                    <h5>Telecom Expertise</h5>
                    <p>
                      With a wealth of industry knowledge, we deliver customized
                      telecom solutions that effectively solve targeted
                      challenges.
                    </p>
                  </div>
                </div>
              </Col>
              <Col xs={12} md={6} lg={6} xl={4} xxl={4} className="mb-4">
                <div
                  className="trusted_ecomm_box"
                  style={{ background: "#31475F" }}
                >
                  <div className="ecomm_title">03</div>
                  <div className="ecomm_box_content">
                    <h5>Integration</h5>
                    <p>
                      By expertly integrating a range of technologies and
                      systems, we guarantee that your telecom software operates
                      effectively within your existing infrastructure.
                    </p>
                  </div>
                </div>
              </Col>
              <Col
                xs={12}
                md={6}
                lg={6}
                xl={4}
                xxl={4}
                className="mb-xl-0 mb-4"
              >
                <div
                  className="trusted_ecomm_box"
                  style={{ background: "#31475F" }}
                >
                  <div className="ecomm_title">04</div>
                  <div className="ecomm_box_content">
                    <h5>Cost-effective & Tech-savvy</h5>
                    <p>
                      We fuse innovative technology with cost-effective
                      solutions, ensuring that our telecom offerings deliver
                      exceptional quality while keeping expenses low.
                    </p>
                  </div>
                </div>
              </Col>
              <Col xs={12} md={6} lg={6} xl={4} xxl={4}>
                <div
                  className="trusted_ecomm_box"
                  style={{ background: "#31475F" }}
                >
                  <div className="ecomm_title">05</div>
                  <div className="ecomm_box_content">
                    <h5>Agile Methodology</h5>
                    <p>
                      We adopt agility to quickly adapt to changing needs and
                      promote collaboration and incremental improvements in your
                      telecom software development.
                    </p>
                  </div>
                </div>
              </Col>
              <Col xs={12} md={6} lg={6} xl={4} xxl={4}>
                <div
                  className="trusted_ecomm_box"
                  style={{ background: "#31475F" }}
                >
                  <div className="ecomm_title">06</div>
                  <div className="ecomm_box_content">
                    <h5>Omnichannel Experience</h5>
                    <p>
                      Our omnichannel experience strategy guarantees smooth user
                      interactions across several platforms, encouraging user
                      engagement with reliable assistance and support.
                    </p>
                  </div>
                </div>
              </Col>
            </Row>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Whychooseecommerce;
